import classNames from "classnames";
import keys from "lodash/keys";
import map from "lodash/map";
import size from "lodash/size";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router";

const CAROUSEL_INTERVAL = 2800;

class MinimizedViewNotifications extends Component {
    constructor() {
        super();

        this.state = { currentAvatarIndex: 0 };
        this.coarouselId = undefined;

        this.cycleAvatarCarousel = this.cycleAvatarCarousel.bind(this);
        this.resetCarousel = this.resetCarousel.bind(this);
        this.startCarousel = this.startCarousel.bind(this);
    }

    componentDidMount() {
        const notificationCount = size(this.props.notificationsGroupedByAvatar);

        if (notificationCount > 1) {
            this.startCarousel();
        }
    }

    componentWillReceiveProps(nextProps) {
        const currentAvatarCount = size(this.props.notificationsGroupedByAvatar);
        const nextAvatarCount = size(nextProps.notificationsGroupedByAvatar);

        if (nextAvatarCount !== currentAvatarCount) {
            this.resetCarousel();
            this.setState({ currentAvatarIndex: 0 });

            if (nextAvatarCount > 1) {
                this.startCarousel();
            }
        }
    }

    componentWillUnmount() {
        this.resetCarousel();
    }

    startCarousel() {
        this.coarouselId = window.setInterval(this.cycleAvatarCarousel, CAROUSEL_INTERVAL);
    }

    resetCarousel() {
        window.clearInterval(this.coarouselId);
        this.coarouselId = undefined;
    }

    cycleAvatarCarousel() {
        const { currentAvatarIndex } = this.state;
        const { notificationsGroupedByAvatar } = this.props;
        const avatarCount = size(notificationsGroupedByAvatar) - 1;
        const nextAvatarIndex = currentAvatarIndex === avatarCount ? 0 : currentAvatarIndex + 1;

        this.setState({ currentAvatarIndex: nextAvatarIndex });
    }

    render() {
        const { notificationsGroupedByAvatar, pathToMaximize, unreadMessagesCount } = this.props;
        const { currentAvatarIndex } = this.state;

        return (
            <Link className="MinimizedView MinimizedView--Notifications" to={pathToMaximize}>
                <div className="MinimizedView__notification">{unreadMessagesCount}</div>
                {map(keys(notificationsGroupedByAvatar), (avatarSrc, key) => (
                    <img
                        alt=""
                        className={classNames({
                            MinimizedView__avatar: true,
                            "MinimizedView__avatar--current": currentAvatarIndex === key,
                        })}
                        height="84"
                        key={key}
                        src={avatarSrc}
                        width="84"
                    />
                ))}
            </Link>
        );
    }
}

MinimizedViewNotifications.propTypes = {
    notificationsGroupedByAvatar: PropTypes.objectOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                avatarSrc: PropTypes.string.isRequired,
                questionUuid: PropTypes.string.isRequired,
                responseId: PropTypes.number.isRequired,
                unreadMessages: PropTypes.number.isRequired,
            })
        ).isRequired
    ).isRequired,
    pathToMaximize: PropTypes.string.isRequired,
    unreadMessagesCount: PropTypes.number.isRequired,
};

export default MinimizedViewNotifications;
